module.exports = __webpack_public_path__ + "static/media/default.58b86f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default.png
// module id = 275
// module chunks = 0